import { ReactNode } from 'react'
import { Text } from '../../../../..'
import styles from '../SavedSearchAlertModal.module.scss'

export interface SavedSearchAlertModalBodySectionProps {
  bodyMsg: string
  children?: ReactNode
}

export const SavedSearchAlertModalBodySection = ({
  bodyMsg,
  children,
}: SavedSearchAlertModalBodySectionProps) => (
  <Text
    variant='neutralCool'
    variantCount='700'
    size='s'
    paragraph
    className={styles.detail}
  >
    {bodyMsg}
    {children && children}
  </Text>
)
